import { useNavigate } from "react-router";
import { InitialPageContainer } from "../../styles/layoutStyles";
import { QuickEstimateInput } from "./types";
import FooterSectionBlock from "./sections/FooterSection";
import HeaderSection from "./sections/HeaderSection";
import HeroSectionBlock from "./sections/HeroSection";
import Cta01Section from "./sections/Cta01Section";
import PointSection from "./sections/PointSection";
import DifferenceSection from "./sections/DifferenceSection";
import WhySection from "./sections/WhySection";
import ReasonSection from "./sections/ReasonSection";
import FaqSection from "./sections/FaqSection";
import Cta02Section from "./sections/Cta02Section";

export default function InitialPage() {
  const navigate = useNavigate();

  const handleQuickEstimateSubmit = (propertyInfo: QuickEstimateInput) => {
    navigate("/customer", { state: { propertyInfo } });
  };

  return (
    <InitialPageContainer>
      <HeaderSection />
      <HeroSectionBlock />
      <Cta01Section onSubmit={handleQuickEstimateSubmit} />
      <PointSection />
      <DifferenceSection />
      <WhySection />
      <ReasonSection />
      <FaqSection />
      <Cta02Section onSubmit={handleQuickEstimateSubmit} />
      <FooterSectionBlock />
    </InitialPageContainer>
  );
}
